export const MAP_OF_TOUR_NAMES_FROM_BE = {
  afterRegistration: 'registration',
  afterFirstBet: '1st_bet',
  casinoTour: 'casino',
  sportsTour: 'sport'
};
